export default {"testimonial1":"MlPva","testimmonial1Slider":"GpZSB","sliderLoaded":"wvIEK","testimonial1Title":"ztclC"};